const gameMarqueeListReducers = (state = [], action) => {
  switch (action.type) {
    case "storeGameMarqueeList":
      return action.payload;
    case "clearMarqueeList":
      return (state = []);
    default:
      return state;
  }
};
export default gameMarqueeListReducers;
